export default __webpack_public_path__ + "static/media/EM0410.34I-22011_-15122_0.dce3dab9.jpg";